import type { EditorThemeClasses } from 'lexical';
const theme: EditorThemeClasses = {
  text: {
    capitalize: 'PlaygroundEditorTheme__textCapitalize',
    lowercase: 'PlaygroundEditorTheme__textLowercase',
    strikethrough: 'PlaygroundEditorTheme__textStrikethrough',
    underline: 'PlaygroundEditorTheme__textUnderline',
    underlineStrikethrough: 'PlaygroundEditorTheme__textUnderlineStrikethrough',
    uppercase: 'PlaygroundEditorTheme__textUppercase',
  },
}
export default theme;